module.exports = __webpack_public_path__ + "static/img/case2.c720221.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/h5/case2.png
// module id = 9aZv
// module chunks = 34